import { EmptyState } from "@/components/EmptyState";
import { Icon } from "@/components/Icon";
import { ConversationsListPanel } from "@/components/ConversationsListPanel";
import { useTwoPane } from "@/hooks/useMediaQuery";

/** Rota /conversas: no expandido a lista vive no painel esquerdo do shell. */
export default function ConversationsScreen() {
  const twoPane = useTwoPane();
  if (twoPane) {
    return (
      <EmptyState
        className="h-full"
        icon={<Icon name="conversas" size={34} />}
        title="Selecione uma conversa"
        description="Escolha uma conversa na lista ao lado para ler e responder."
      />
    );
  }
  return <ConversationsListPanel />;
}
